<template>
  <label class="nc-toggle" :class="{ 'nc-toggle--disabled': disabled }">
    <span v-if="label" class="nc-toggle__label">{{ label }}</span>
    <button
      type="button"
      role="switch"
      :aria-checked="modelValue"
      class="nc-toggle__track"
      :class="modelValue ? 'nc-toggle__track--on' : 'nc-toggle__track--off'"
      :disabled="disabled"
      @click="toggle"
    >
      <span class="nc-toggle__thumb" :class="modelValue ? 'nc-toggle__thumb--on' : 'nc-toggle__thumb--off'" />
    </button>
  </label>
</template>

<script>
export default {
  name: 'NcToggle',
  props: {
    modelValue: { type: Boolean, default: false },
    label: { type: String, default: '' },
    disabled: { type: Boolean, default: false },
  },
  emits: ['update:modelValue'],
  methods: {
    toggle() {
      if (!this.disabled) {
        this.$emit('update:modelValue', !this.modelValue);
      }
    },
  },
};
</script>

<style scoped>
.nc-toggle {
  display: inline-flex;
  align-items: center;
  gap: var(--nc-spacing-sm);
  cursor: pointer;
}

.nc-toggle--disabled {
  opacity: 0.4;
  pointer-events: none;
}

.nc-toggle__label {
  font-size: var(--nc-font-size-sm);
  color: var(--nc-text);
}

.nc-toggle__track {
  position: relative;
  width: 44px;
  height: 26px;
  border-radius: var(--nc-radius-full);
  border: none;
  padding: 2px;
  cursor: pointer;
  transition: background var(--nc-transition-fast);
  -webkit-appearance: none;
  appearance: none;
}
/* Tikgebied minimaal 44px hoog (iOS HIG / WCAG 2.5.5); breedte is al 44px. */
.nc-toggle__track::after {
  content: "";
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  min-width: 44px;
  min-height: 44px;
}

.nc-toggle__track--off {
  background: var(--nc-border);
}

.nc-toggle__track--on {
  background: var(--nc-color-primary);
}

.nc-toggle__thumb {
  display: block;
  width: 22px;
  height: 22px;
  border-radius: var(--nc-radius-full);
  background: white;
  box-shadow: var(--nc-shadow-sm);
  transition: transform var(--nc-transition-fast);
}

.nc-toggle__thumb--off {
  transform: translateX(0);
}

.nc-toggle__thumb--on {
  transform: translateX(18px);
}
</style>
